import createTheme from '@sift/skipper/styles/createTheme';
import palette from './palette';
import skipperDefaultPalette from '@sift/skipper/styles/skipperDefaultPalette';

export default createTheme({
  typography: {
    fontFamily: 'Source Sans Pro, sans-serif',
    h2: {
      fontWeight: 400,
    },
  },
  palette,
  overrides: {
    MuiFormLabel: {
      root: {
        color: skipperDefaultPalette.text.gray1,
      },
    },
  },
});
